export default "__VITE_ASSET__WZtD3Q2o__"